<template>
    <nav aria-label="breadcrumb" v-if="supergroups.length > 0">
      <ol class="breadcrumb bg-light p-2 rounded">
        <li v-for="(supergroup, index) in supergroups" :key="supergroup.uuid" class="breadcrumb-item" :class="{ active: index === supergroups.length - 1 }">
          <a v-if="index < supergroups.length - 1" :href="supergroupLink(supergroup.uuid)">{{ supergroup.name }}</a>
          <a v-else aria-current="page" :href="supergroupLink(supergroup.uuid)">{{ supergroup.name }}</a>
        </li>
      </ol>
    </nav>
  </template>
  
  <script>
  export default {
    name: 'SupergroupBreadcrumb',
    computed: {
      supergroups() {
        const unorderedSupergroups = this.$angularWorld.domainInfo?.domainInfoRecordUI?.domainInfoRecord?.supergroups || [];
        return this.sortSupergroups(unorderedSupergroups);
      }
    },
    methods: {
      sortSupergroups(supergroups) {
        return supergroups.sort((a, b) => {
          if (a.parent_id === b.uuid) return -1;
          if (b.parent_id === a.uuid) return 1;
          return 0;
        }).reverse();
      },
      supergroupLink(uuid) {
        return `#!/supergroups#${uuid}`;
      }
    }
  };
  </script>